// authMallToken JWT 페이로드에서 IMP buyer_* 용 결제자(=로그인 유저) 정보를 추출.
// tokenData 가 null/undefined 이거나 필드가 비어있으면 빈 문자열로 정규화 — IMP 가 undefined 를 거부하지 않도록.
// SMS 영수증은 buyer_tel(phone) 로 발송되므로 name/phone 누락만 silent failure 위험 (SAM-119).
// email 은 영수증 이메일용 — NULL email 회원이 운영상 다수라 차단 대상에서 제외, warn 으로 가시성만 유지.
export function extractOrdererInfo(tokenData) {
  if (!tokenData) return { name: '', phone: '', email: '' };
  const orderer = {
    name: tokenData.name ?? '',
    phone: tokenData.phone ?? '',
    email: tokenData.email ?? '',
  };
  if (!orderer.name || !orderer.phone || !orderer.email) {
    console.warn('[ordererInfo] token payload missing fields', {
      hasName: !!orderer.name,
      hasPhone: !!orderer.phone,
      hasEmail: !!orderer.email,
    });
  }
  return orderer;
}
